import { useEffect, useState } from "react";
import { navItems } from "@/mocks/siteContent";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const [active, setActive] = useState("overview");

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 40);
      let current = navItems[0].id;
      navItems.forEach((item) => {
        const el = document.getElementById(item.id);
        if (el && el.getBoundingClientRect().top <= 140) {
          current = item.id;
        }
      });
      setActive(current);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id: string) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        scrolled || open
          ? "bg-background-50/95 backdrop-blur border-b border-background-200/70"
          : "bg-transparent"
      }`}
    >
      <nav className="w-full px-4 md:px-8 h-16 flex items-center justify-between">
        <button
          type="button"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="flex items-center gap-2 cursor-pointer shrink-0"
        >
          <span className="w-8 h-8 flex items-center justify-center rounded-md bg-primary-500 text-background-50">
            <i className="ri-home-heart-line text-base" aria-hidden="true"></i>
          </span>
          <span
            className={`font-heading text-lg font-bold whitespace-nowrap ${
              scrolled || open ? "text-foreground-950" : "text-background-50"
            }`}
          >
            邻居的妻子 · 题材站
          </span>
        </button>

        <ul className="hidden lg:flex items-center gap-1">
          {navItems.map((item) => (
            <li key={item.id}>
              <button
                type="button"
                onClick={() => go(item.id)}
                className={`px-3 py-2 text-sm rounded-md whitespace-nowrap cursor-pointer transition-colors ${
                  active === item.id
                    ? "text-primary-600 font-medium bg-primary-50"
                    : scrolled
                    ? "text-foreground-700 hover:text-primary-600 hover:bg-background-100"
                    : "text-background-50/90 hover:text-background-50 hover:bg-background-50/15"
                }`}
              >
                {item.label}
              </button>
            </li>
          ))}
        </ul>

        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          aria-label="打开导航菜单"
          aria-expanded={open}
          className={`lg:hidden w-10 h-10 flex items-center justify-center rounded-md cursor-pointer ${
            scrolled || open ? "text-foreground-950" : "text-background-50"
          }`}
        >
          <i className={open ? "ri-close-line text-2xl" : "ri-menu-3-line text-2xl"} aria-hidden="true"></i>
        </button>
      </nav>

      {open && (
        <div className="lg:hidden border-t border-background-200/70 bg-background-50 px-4 pb-4 pt-2">
          <ul className="grid grid-cols-2 gap-2">
            {navItems.map((item) => (
              <li key={item.id}>
                <button
                  type="button"
                  onClick={() => go(item.id)}
                  className={`w-full text-left px-3 py-2.5 text-sm rounded-md cursor-pointer transition-colors ${
                    active === item.id
                      ? "bg-primary-50 text-primary-600 font-medium"
                      : "text-foreground-700 hover:bg-background-100"
                  }`}
                >
                  {item.label}
                </button>
              </li>
            ))}
          </ul>
        </div>
      )}
    </header>
  );
}